import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { EyeIcon } from "../../../assets/icons";
import useSlideOver from "../../SlideOver/useSlideOver";
import UseContext from "../../../hooks/useContext";
import { dateWordShort } from "../../../helper/helper";
import TableCell from "./TableCell";
import TableRow from "./TableRow";

const Tbodycompany = ({ champsBody }) => {
    const { setObjID } = UseContext();
    const { toggleSlideOver } = useSlideOver();
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedId, setSelectedId] = useState(null);

    const openCompanyInfo = (id) => {
        setObjID(id);
        toggleSlideOver('get_company');
        navigate('/company?idCompany=' + id);
    };

    useEffect(() => {
        const id = new URLSearchParams(location.search).get('idCompany');
        setSelectedId(id);
        if (id) openCompanyInfo(id);
    }, [location.search]);

    return (
        <>
            {champsBody?.map((company) => (
                <TableRow
                    key={company._id}
                    itemId={company._id}
                    selectedId={selectedId}
                    onClick={openCompanyInfo}
                >
                    <TableCell position="first" columnIndex={0}>
                        {company.name_commercial}
                    </TableCell>
                    <TableCell columnIndex={1}>
                        {company.bigAccounts?.join(', ')}
                    </TableCell>
                    <TableCell columnIndex={2}>
                        {dateWordShort(new Date(company.createdAt))}
                    </TableCell>
                    <TableCell
                        position="last"
                        hasButton
                        buttonOnClick={(e) => {
                            e.stopPropagation();
                            openCompanyInfo(company._id);
                        }}
                        buttonContent={<EyeIcon wh={20} color={'#374151'} />}
                    />
                </TableRow>
            ))}
        </>
    );
};

export default Tbodycompany;